import { Component } from '@angular/core';

@Component({
  selector: 'nb-modal-footer',
  templateUrl: './nb-modal-footer.component.html',
  styleUrls: ['./nb-modal-footer.component.scss'],
})
export class NbModalFooterComponent {}
